import Transforms from './transforms'

const endpoints = {
    list: {
        path: '/entities/dictionaries',
        transform: Transforms.list,
    },
    get: {
        path: '/entities/dictionaries/:dictKey',
        transform: Transforms.get,
    },
    create: {
        method: 'POST',
        path: '/entities/dictionaries',
    },
    delete: {
        method: 'DELETE',
        path: '/entities/dictionaries/:dictKey',
    },
    edit: {
        method: 'PUT',
        path: '/entities/dictionaries/:dictKey',
    },
    order: {
        method: 'PUT',
        path: '/entities/dictionaries/:dictKey/:fieldType',
    },
    fieldCreate: {
        method: 'POST',
        path: '/entities/dictionaries/:dictKey/:fieldType/:fieldKey',
    },
    fieldEdit: {
        method: 'DELETE',
        path: '/entities/dictionaries/:dictKey/:fieldType/:fieldKey',
    },
    fieldDelete: {
        method: 'PUT',
        path: '/entities/dictionaries/:dictKey/:fieldType/:fieldKey',
    },
}

export default {
    name: 'dictionaries',
    endpoints,
}
